
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[pages]",
      function () {
        return require("private-next-pages/content/[pages].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[pages]"])
      });
    }
  